import { render, staticRenderFns } from "./OverdueRequestsChart.vue?vue&type=template&id=63d751f8&scoped=true"
import script from "./OverdueRequestsChart.vue?vue&type=script&lang=js"
export * from "./OverdueRequestsChart.vue?vue&type=script&lang=js"
import style0 from "./OverdueRequestsChart.vue?vue&type=style&index=0&id=63d751f8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d751f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d751f8')) {
      api.createRecord('63d751f8', component.options)
    } else {
      api.reload('63d751f8', component.options)
    }
    module.hot.accept("./OverdueRequestsChart.vue?vue&type=template&id=63d751f8&scoped=true", function () {
      api.rerender('63d751f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/components/OverdueRequestsChart.vue"
export default component.exports